import {Button, ButtonProps, useToken} from '@chakra-ui/react';
import {motion} from 'framer-motion';

import {useTriviaStore} from '../../state';
import type {Answer} from '../../types';

interface TextAnswerProps extends ButtonProps {
  answer: Answer;
  questionAnsweredCorrectly: boolean;
}

export const TextAnswer = ({answer, questionAnsweredCorrectly, ...props}: TextAnswerProps) => {
  const [blackColor, green400Color] = useToken('colors', ['black', 'green.400']);

  const isActive = useTriviaStore((state) => !!state.currentAnswer.find(({id}) => id === answer.id));

  const isCorrect = isActive && questionAnsweredCorrectly;

  return (
    <Button
      data-testid="answer"
      as={motion.button}
      variant="unstyled"
      h="unset"
      minH="10"
      bg="#f8f8f8"
      paddingInline="4"
      py="2"
      borderWidth="1px"
      borderColor="#c7c7c7"
      color="#191b20"
      fontSize="md"
      fontWeight="600"
      transitionProperty="background, border-color, color, shadow"
      transitionDuration="normal"
      _hover={{}}
      _active={{
        bg: 'black',
        borderColor: 'black',
        color: 'white',
        fontWeight: 700,
        shadow: '0 4px 8px rgb(0 0 0 / 0.25), inset 0 2px 6px #626262',
      }}
      _disabled={{opacity: 0.4, cursor: 'not-allowed', _hover: {borderColor: '#c7c7c7'}}}
      {...props}
      isActive={isActive}
      isDisabled={props.isDisabled && !isActive}
      animate={
        isCorrect
          ? {
              backgroundColor: [blackColor, green400Color],
              borderColor: [blackColor, green400Color],
              transition: {
                duration: 0.1,
                ease: 'linear',
              },
            }
          : {}
      }
      userSelect="none"
      onCopy={(e) => e.preventDefault()}
    >
      {answer.body}
    </Button>
  );
};
